export const TammiRange = {
    makeContinuous: (beginValue: number, times: number, step: number) => {
        return new Array<number>(times).fill(1).map((_, i) => beginValue + i * step);
    }
}